import { GET_API_ANSWERS_BY_MATRIX,GET_API_ANSWER_GRADERS_BY_ANSWER} from '../actions/apiActions';

/**
 * Manejo de la parte del estado correspondiente a matrices de codificación.
 * Permite la actualización de matrices de codificación, obtener una matriz de codificación por id.
 * Permite eliminar una matriz de codificación de la lista de matrices de codificación disponibles.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a las matrices)
 * @returns El estado con la modificación/acción realizada.
 */

const initialState = {
  // answers: undefined,
  // answerGraders: undefined
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_API_ANSWERS_BY_MATRIX:
      const answers = action.payload;
      return {...state, answers};
    case GET_API_ANSWER_GRADERS_BY_ANSWER:
      const answerGraders = action.payload;
      return {...state,  answerGraders };
    default:
      return state;
  }
}
